import { makeStyles } from '@material-ui/core/styles';
import { Grid, Paper, Typography } from '@material-ui/core';
import { Link } from '@backstage/core-components';
import { iconsApiRef, useApi } from '@backstage/frontend-plugin-api';
import { featureNavigationData } from './featureNavigationData';

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(3),
    textAlign: 'center',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'transform 0.2s, box-shadow 0.2s',
    '&:hover': {
      transform: 'translateY(-4px)',
      boxShadow: theme.shadows[8],
    },
  },
  iconWrapper: {
    marginBottom: theme.spacing(2),
    fontSize: '3rem',
    color: theme.palette.primary.main,
    '& svg': {
      fontSize: 'inherit',
      transition: 'color 0.2s',
    },
  },
  title: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    color: theme.palette.primary.main,
    fontSize: '1.25rem',
  },
  description: {
    color: theme.palette.text.secondary,
    fontSize: '1rem',
  },
  link: {
    color: 'inherit',
    textDecoration: 'none',
    display: 'block',
    height: '100%',
    '&:hover': {
      textDecoration: 'none',
    },
    '&:hover $iconWrapper svg': {
      color: theme.palette.primary.main,
    },
  },
}));

export const FeatureNavigationTiles = () => {
  const classes = useStyles();
  const iconsApi = useApi(iconsApiRef);

  return (
    <Grid container spacing={2} style={{ marginBottom: '8px' }}>
      {featureNavigationData.map(featureNavigation => {
        return (
          <Grid item xs={12} sm={6} md={3} key={featureNavigation.title}>
            <Link
              to={featureNavigation.link}
              className={classes.link}
              aria-label={featureNavigation.ariaLabel}
            >
              <Paper className={classes.paper}>
                <div className={classes.iconWrapper} aria-hidden="true">
                  {iconsApi.icon(featureNavigation.iconKey)}
                </div>
                <Typography variant="h6" className={classes.title}>
                  {featureNavigation.title}
                </Typography>
                <Typography variant="body2" className={classes.description}>
                  {featureNavigation.description}
                </Typography>
              </Paper>
            </Link>
          </Grid>
        );
      })}
    </Grid>
  );
};
